import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule, PopoverController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ModalData, ModalOption } from '../../type/modal';

@Component({
    selector: 'app-button-popover',
    standalone: true,
    imports: [CommonModule, IonicModule, TranslateModule],
    templateUrl: './button-popover.component.html',
    styleUrl: './button-popover.component.scss',
})
export class ButtonPopoverComponent {
    @Input() modalOption!: ModalOption;
    constructor(private popoverController: PopoverController) {}

    dismiss() {
        this.popoverController.dismiss();
      }
}
